import { CubeTimeDimensionGranularity } from "../../../enum/cube-schema.enum";

export interface GetAllScoresRequestParamsDto {
    startDate: string;
    endDate: string;
    timezone?: string;
    granularity?: CubeTimeDimensionGranularity;
}